import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';

import React, { Component } from 'react';
import AlertDanger from 'components/alerts/AlertDanger/AlertDanger';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError, change } from 'redux-form';
import Loading from 'components/Loading/Loading';
import { USER_ROLE } from 'config/constants';
import { changeUserEmail } from 'actions/Admin/accountActions';

import { trimUserInput } from '../../../../utils/formHelpers';

import './style.css';

const renderField = ({
  input, label, type, disabled
}) => {
  return (
    <div>
      <div className="input-wrapper">
        <div className="text-left px-4">
          <small>{label}</small>
        </div>
        <input id={input.name} className="border-0 px-4" {...input} disabled={disabled} type={type} />
      </div>
    </div>
  );
};

class SearchAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = { results: null, loading: false, error: null };
  }

  handlePauseSubmit = values => {
    this.setState({ error: null });
    const user = this.state.results[0];
    const { endDate } = values;

    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/admin/accounts/pause`,
          {
            endDate,
            accountId: user.id
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.props.user.token}`
            }
          }
        )
        .then(response => {
          this.setState({ results: [response.data.data] });
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    }).catch(ex => {
      this.setState({ error: ex });
    });
  }

  handleSyncStripe = () => {
    this.setState({ error: null });
    const user = this.state.results[0];

    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/admin/accounts/sync_stripe`,
          {
            accountId: user.id
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.props.user.token}`
            }
          }
        )
        .then(response => {
          this.setState({ results: [response.data.data] });
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    }).catch(ex => {
      this.setState({ error: ex });
    });
  }

  handleAddCreditsSubmit = values => {
    this.setState({ error: null });
    const user = this.state.results[0];
    const { quantity } = values;

    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/admin/accounts/add_credits`,
          {
            quantity,
            accountId: user.id
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.props.user.token}`
            }
          }
        )
        .then(response => {
          this.setState({ results: [response.data.data] });
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    }).catch(ex => {
      this.setState({ error: ex });
    });
  }

  handleRemoveUnusedCreditsSubmit = (values) => {
    const user = this.state.results[0];
    const { removeQuantity: quantity } = values;

    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/admin/accounts/remove_manual_credits`,
          {
            quantity,
            accountId: user.id
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.props.user.token}`
            }
          }
        )
        .then(response => {
          this.setState({ results: [response.data.data] });
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    }).catch(ex => {
      throw new SubmissionError(ex);
    });
  }

  handleChangeEmail = values => {
    this.setState({ error: null });
    const user = this.state.results[0];
    const { newEmail } = values;

    return new Promise((resolve, reject) => {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(newEmail)) {
        reject(new Error('Invalid email address'));
      }
      const data = {
        newEmail: newEmail,
        accountId: user.id
      };
      this.props.changeUserEmail(data, response => {
        this.setState({ results: [response.data.data] });
        this.props.dispatch(change('adminSearchUsersForm', 'newEmail', null));
        this.props.dispatch(change('adminSearchUsersForm', 'email', newEmail));
        resolve();
      }, error => {
        reject(error);
      });
    }).catch(ex => {
      this.setState({ error: ex });
    });
  }

  handleFormSubmit = values => {
    this.setState({ error: null });
    // clean up any user input
    const userInput = trimUserInput(values);

    // pick off the values we want
    const { email } = userInput;

    if (this.state.results === []) {
      this.setState({ results: null, loading: true });
    }

    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/admin/accounts?email=${email}`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.props.user.token}`
          }
        })
        .then(response => {
          this.setState({ results: response.data.data, loading: false });
          resolve();
        })
        .catch(error => {
          this.setState({ loading: false });
          reject(error);
        });
    }).catch(ex => {
      this.setState({ loading: false, error: ex });
    });
  }

  friendlyUTC = (isoString) => {
    return isoString ? moment.utc(isoString).format('MMM DD, YYYY h:mma') + ' UTC' : 'None';
  }

  dataUTC = (isoString) => {
    return moment.utc(isoString).format('MM/DD/YYYY h:mma') + ' UTC';
  }

  pauseDuration = (isoString1, isoString2) => {
    const d1 = moment.utc(isoString1);
    const d2 = moment.utc(isoString2);
    const differenceInDays = d1.diff(d2, 'days');
    if (differenceInDays > 0) {
      return `${differenceInDays} days`;
    }

    const differenceInHours = d1.diff(d2, 'hours');
    if (differenceInHours > 0) {
      return `${differenceInHours} hours`;
    }

    const differenceInMinutes = d1.diff(d2, 'minutes');
    if (differenceInMinutes > 0) {
      return `${differenceInMinutes} minutes`;
    }

    return 'No time at all!';
  }

  canUserBePaused = (user) => {
    if (!user.stripePlan) {
      return [false, 'We have no stripe plan for this user. Try syncing?'];
    }
    if (user.stripePlan.isPrepaid) {
      return [false, 'This user may not be paused because they are on a prepaid plan'];
    }
    if (user.minutesLeft.isTrialPeriod) {
      return [false, 'This user may not be paused because they are in their trial period'];
    }
    return [true, null];
  }

  getErrorWithResponse = () => {
    if (!this.state.error) return null;
    const { error } = this.state;
    return {
      statusText: null,
      message: error.response && error.response.data ? error.response.data : error.message
    };
  }

  renderSearchForm() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;
    return (
      <form className="HelpForm form" onSubmit={handleSubmit(this.handleFormSubmit)}>
        <div className="d-flex justify-content-center filter-form">
          {error && <p className="text-danger my-2">{error}</p>}
          <Field
            name="email"
            component={renderField}
            type="email"
            label="Email"
            placeholder="Email"
          />
          <button disabled={submitting || pristine} type="submit" className="ml-2 btn btn-primary">
            Search
          </button>
        </div>
      </form>
    );
  }

  renderPauseForm() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;
    return (
      <form className="HelpForm form" onSubmit={handleSubmit(this.handlePauseSubmit)}>
        <div className="d-flex filter-form">
          {error && <p className="text-danger my-2">{error}</p>}
          <Field
            name="endDate"
            component={renderField}
            type="date"
            label="End Date"
            placeholder="End Date"
          />
          <button disabled={submitting || pristine} type="submit" className="ml-2 btn btn-primary">
            Pause
          </button>
        </div>
      </form>
    );
  }

  renderAddCreditsForm() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;
    return (
      <form className="HelpForm form" onSubmit={handleSubmit(this.handleAddCreditsSubmit)}>
        <div className="d-flex filter-form">
          {error && <p className="text-danger my-2">{error}</p>}
          <Field
            name="quantity"
            component={renderField}
            type="number"
            label="Quantity"
            placeholder="Quantity"
          />
          <button disabled={submitting || pristine} type="submit" className="ml-2 btn btn-primary">
            Add Credits
          </button>
        </div>
      </form>
    );
  }

  renderRemoveUnusedCreditsForm() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;
    return (
      <form className="HelpForm form" onSubmit={handleSubmit(this.handleRemoveUnusedCreditsSubmit)}>
        <div className="d-flex filter-form">
          {error && <p className="text-danger my-2">{error}</p>}
          <Field
            name="removeQuantity"
            component={renderField}
            type="number"
            label="Quantity"
            placeholder="Quantity"
          />
          <button disabled={submitting || pristine} type="submit" className="ml-2 btn btn-primary">
            Remove Credits
          </button>
        </div>
      </form>
    );
  }

  renderSyncStripeForm() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;
    return (
      <form className="HelpForm form" onSubmit={handleSubmit(this.handleSyncStripe)}>
        <div className="d-flex filter-form">
          {error && <p className="text-danger my-2">{error}</p>}
          <button disabled={submitting || pristine} type="submit" className="ml-2 btn btn-primary">
            Sync Stripe
          </button>
        </div>
      </form>
    );
  }

  renderAppointmentList(appointments) {
    if (_.isEmpty(appointments)) return <div>None</div>;
    return (
      <div>
        {appointments.map(a => {
          return (
            <div key={a.id}>
              <strong>{this.dataUTC(a.startTime)}</strong> {a.service.description} for {a.duration}{' '}
              minutes with {a.teacher.name} (status {a.status})
            </div>
          );
        })}
      </div>
    );
  }

  renderPauseHistory(allPauses) {
    if (_.isEmpty(allPauses)) return <div>None</div>;
    return (
      <div>
        {_.orderBy(allPauses, 'resumeDate', 'desc').map(p => {
          return (
            <div key={p.id}>
              Paused {this.dataUTC(p.startDate)} for {this.pauseDuration(p.resumeDate, p.startDate)}
            </div>
          );
        })}
      </div>
    );
  }

  renderCreditsList(credits) {
    if (_.isEmpty(credits)) return <div>None</div>;
    const manual = credits.filter(c => !c.rolloverId).length;
    const rollover = credits.filter(c => !!c.rolloverId).length;
    return (
      <div>
        <div>
          <strong>{manual}</strong> credits added by Rype
        </div>
        <div>
          <strong>{rollover}</strong> credits from roll overs
        </div>
      </div>
    );
  }

  renderEmailChangeForm() {
    const {
      error, handleSubmit, pristine, submitting
    } = this.props;
    return (
      <form className="HelpForm form my-3" onSubmit={handleSubmit(this.handleChangeEmail)}>
        <div className="d-flex filter-form">
          {error && <p className="text-danger my-2">{error}</p>}
          <Field
            name="newEmail"
            component={renderField}
            type="email"
            label="Email"
            placeholder="Email"
          />
          <button disabled={submitting || pristine} type="submit" className="ml-2 btn btn-primary">
            Change Email
          </button>
        </div>
      </form>
    );
  }

  renderStudentInfo(canPause, pauseError, result) {
    return ((
      <React.Fragment>
        <div className="info-section stripe-section">
          <div className="section-title">Stripe Plan</div>
          {result.live_subscription && result.stripePlan && (
            <div>
              <div>Name: {result.stripePlan.name} </div>
              <div>ID: {result.live_subscription.stripePlanId}</div>
              <div>Start: {this.friendlyUTC(result.live_subscription.planStartedAt)}</div>
              <div>
                Trial Start: {this.friendlyUTC(result.live_subscription.trialStart)}
              </div>
              <div>Trial End: {this.friendlyUTC(result.live_subscription.trialEnd)}</div>
            </div>
          )}
          {!result.live_subscription && (
            <div>
              <strong>ERROR: MISSING LIVE SUBSCRIPTION</strong>
            </div>
          )}
          {!result.stripePlan && (
            <div>
              <strong>ERROR: MISSING STRIPE PLAN</strong>
            </div>
          )}
        </div>

        <div className="info-section cycle-section">
          <div className="section-title">Cycle</div>
          {!_.isEmpty(result.minutesLeft) && (
            <div>
              <div>
                Current Start: {this.friendlyUTC(result.minutesLeft.current.start)}
              </div>
              <div>Current End: {this.friendlyUTC(result.minutesLeft.current.end)}</div>
              <div>Current Minutes Left: {result.minutesLeft.current.minutes}</div>
              <div>Next Start: {this.friendlyUTC(result.minutesLeft.next.start)}</div>
              <div>Next Minutes Left: {result.minutesLeft.next.minutes}</div>
            </div>
          )}
          {_.isEmpty(result.minutesLeft) && (
            <div>
              <strong>
                ERROR: NO MINUTES LEFT INFO (missing stripe plan or subcription?)
        </strong>
            </div>
          )}
        </div>

        <div className="info-section credits-section">
          <div className="section-title">Unused Credits</div>
          {this.renderCreditsList(result.unusedCredits)}
        </div>

        {!_.isEmpty(result.minutesLeft) && (
          <div className="info-section appointments-section">
            <div className="section-title">Current Cycle Appointments</div>
            {this.renderAppointmentList(result.curCycleAppointments)}
            <div className="section-title">Next Cycle Appointments</div>
            {this.renderAppointmentList(result.nextCycleAppointments)}
          </div>
        )}

        <div className="info-section">
          <div className="section-title">Pause History</div>
          {this.renderPauseHistory(result.allPauses)}
        </div>

        {!result.pause && (
          <div className="info-section pause-action-section">
            <div className="section-title">Pause</div>
            <div>
              {!canPause && (
                <p>
                  <strong>{pauseError}</strong>
                </p>
              )}
              {canPause && (
                <div>
                  <p>
                    Pauses take effect immediately. When pausing from the admin interface,
                    we do not check for abuse so please review pause history to make sure
                    user is not abusing.
                  </p>
                  {this.renderPauseForm()}
                </div>
              )}
            </div>
          </div>
        )}
        <div className="info-section credits-action-section">
          <div className="section-title">Add Credits</div>
          {this.renderAddCreditsForm()}
        </div>
        <div className="info-section credits-action-section">
          <div className="section-title">Remove Unused Credits</div>
          {this.renderRemoveUnusedCreditsForm()}
        </div>
      </React.Fragment>
    ))
  }

  render() {
    let state;
    let result = null;
    if (this.state.loading) {
      state = 'loading';
    } else if (this.state.results === null) {
      state = 'start';
    } else if (!this.state.results[0]) {
      state = 'empty';
    } else {
      [result] = this.state.results;
      state = 'results';
    }

    let canPause;
    let pauseError;
    let userRole;
    if (result) {
      userRole = result.role;
      [canPause, pauseError] = this.canUserBePaused(result);
    }

    return (
      <div className="SearchAccounts">
        <div className="col-auto">
          {this.state.error && (
            <div className="row mb-2">
              <AlertDanger error={this.getErrorWithResponse()} />
            </div>
          )}
          <div className="row">{this.renderSearchForm()}</div>
          <div className="row">
            <div className="card">
              {state === 'loading' && <Loading />}
              {state === 'start' && <div className="message">Enter an email address above</div>}
              {state === 'empty' && <div className="message">NO RESULT</div>}
              {state === 'results' && (
                <div className="user-information">
                  {result.picture && result.picture.url && (
                    <div className="info-section photo-section">
                      <img src={result.picture.url} alt="" />
                    </div>
                  )}

                  <div className="info-section basic-section">
                    <div className="large-text">{result.name}</div>
                    {!_.isEmpty(result.pause) && (
                      <div>
                        <span style={{ color: 'red' }}>
                          Paused {this.dataUTC(result.pause.startDate)}
                        </span>{' '}
                        (resumes {this.dataUTC(result.pause.endDate)})
                      </div>
                    )}
                    <div>{result.email}</div>
                    {this.renderEmailChangeForm()}
                    <div>Joined {moment.utc(result.createdAt).format('MMM DD, YYYY')}</div>
                    {userRole === USER_ROLE.STUDENT && <div>{this.renderSyncStripeForm()}</div>}
                  </div>
                  {userRole === USER_ROLE.STUDENT && this.renderStudentInfo(canPause, pauseError, result)}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export default compose(
  connect(mapStateToProps, { changeUserEmail }),
  reduxForm({ form: 'adminSearchUsersForm' })
)(SearchAccounts);



// WEBPACK FOOTER //
// ./src/pages/admin/routes/SearchAccounts/index.js